/* eslint-disable jsx-a11y/anchor-is-valid */
import { SearchOutlined } from '@ant-design/icons';
import { Button, Checkbox, Input, Modal } from 'antd';
import classNames from 'classnames';
import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import IconEmpty from '../../../../assets/Images/icons/empty';
import useNotify from '../../../../context/Notification/useNotify';
import RiskRegisterService from '../../../../services/RiskRegister.service';

const ModalAddActivity = ({ open, handelClose, getDetailInfo, riskInfo }) => {
    const { t } = useTranslation();
    const { riskId } = useParams();

    const [loading, setLoading] = useState(false);
    const [activities, setActivities] = useState([]);
    const [selected, setSelected] = useState([]);
    const [checkAll, setCheckAll] = useState(false);
    const [originalActivity, setOriginalActivity] = useState([]);
    const [value, setValue] = useState();
    const notify = useNotify();

    const onChange = ({ target: { checked } }) => {
        if (checked) {
            setSelected(activities);
        } else {
            setSelected([]);
        }
    };

    useEffect(() => {
        if (activities.length > 0)
            if (selected.length !== activities.length) {
                setCheckAll(false);
            } else {
                setCheckAll(true);
            }
    }, [activities.length, selected.length]);

    const saveActivity = () => {
        setLoading(true);
        setTimeout(async () => {
            try {
                const payload = {
                    activityList: selected.map(
                        (activity) => activity.activityId
                    ),
                    riskRegisterId: riskId,
                };
                const { data } = await RiskRegisterService.saveActivity(
                    payload
                );
                if (data?.resultCode === 1) {
                    setLoading(false);
                    getDetailInfo();
                    handelClose();
                    setSelected([]);
                } else {
                    setLoading(false);
                    handelClose();
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('RR.ActivitySelected'),
                        closeable: true,
                        timeOut: 120000,
                    });
                    setSelected([]);
                }
            } catch (error) {
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to submitted'),
                });
                console.log(error);
                setLoading(false);
            }
        }, 1300);
    };

    useEffect(() => {
        const getActivityList = async () => {
            try {
                const { data } = await RiskRegisterService.getActivityList(
                    riskInfo?.departmentId
                );
                if (data?.resultData) {
                    setActivities(data?.resultData);
                    setOriginalActivity(data?.resultData);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getActivityList();
    }, [riskInfo]);

    const onSearch = ({ target: { value } }) => {
        if (value) {
            const search = originalActivity.filter((activity) =>
                activity.activityName
                    .toLowerCase()
                    .includes(value.toLowerCase())
            );
            setActivities(search);
        } else setActivities(originalActivity);
        setValue(value);
    };

    // useEffect(() => {
    //     if (riskInfo?.activityList?.length > 0) {
    //         let items = [];
    //         for (let data of riskInfo?.activityList) {
    //             items.push({
    //                 ...data,
    //                 hidden: true,
    //             });
    //         }
    //         setSelected(items);
    //     }
    // }, [riskInfo]);

    const _handelClose = () => {
        setSelected([]);
        handelClose();
        setValue();
        setActivities(originalActivity);
    };

    return (
        <Modal
            width={450}
            className="_modal"
            footer={false}
            open={open}
            onCancel={_handelClose}
        >
            <div className="text-1xl text-center mb-6">
                {t('RR.AddActivities')}
            </div>
            <div>
                <label>{t('DashBoardRM.RiskActivities')}</label>
                <div
                    style={{ border: '1px solid #DBDBDB' }}
                    className="w-full min-h-[96px] max-h-[300px] overflow-y-auto rounded-lg my-2 p-2"
                >
                    {selected.length > 0 ? (
                        selected.map((activity) => (
                            <span
                                key={activity?.activityId}
                                className={classNames(
                                    'p-0.5 px-1 mr-2 mb-2 rounded inline-flex w-max',
                                    { 'text-gray opacity-60': activity?.hidden }
                                )}
                                style={{ border: '1px solid #B1C8DF' }}
                            >
                                {activity?.activityName}{' '}
                                <a
                                    hidden={activity?.hidden}
                                    onClick={() =>
                                        setSelected(
                                            selected.filter(
                                                (is) =>
                                                    is.activityId !==
                                                    activity.activityId
                                            )
                                        )
                                    }
                                    className="ml-2"
                                >
                                    {xIcon}
                                </a>
                            </span>
                        ))
                    ) : (
                        <p className="text-gray">
                            {t('RR.SelectRiskActivities')}
                        </p>
                    )}
                </div>
                <div
                    style={{ border: '1px solid #DBDBDB' }}
                    className="w-full rounded-lg my-2 p-2"
                >
                    <Input
                        value={value}
                        size="large"
                        placeholder={t('Consent.SearchActivityName')}
                        prefix={<SearchOutlined />}
                        onChange={onSearch}
                    />
                    <Checkbox
                        onChange={onChange}
                        checked={checkAll}
                        className="ml-2 mt-4"
                    >
                        <span className="font-semibold">
                            {t('RList.SelectAll')}
                        </span>
                    </Checkbox>
                    <div className="h-[240px] overflow-y-auto overflow-x-hidden pt-2 pb-4">
                        {activities.length > 0 ? (
                            activities?.map((activity, i) => {
                                const selectId = selected.find(
                                    (is) =>
                                        is.activityId === activity.activityId
                                );
                                return (
                                    <Checkbox
                                        checked={
                                            activity.activityId ===
                                            selectId?.activityId
                                        }
                                        onChange={({ target: { checked } }) => {
                                            if (checked) {
                                                let items = [
                                                    activity,
                                                    ...selected,
                                                ];
                                                setSelected(items);
                                            } else {
                                                setSelected(
                                                    selected.filter(
                                                        (is) =>
                                                            is.activityId !==
                                                            activity.activityId
                                                    )
                                                );
                                            }
                                        }}
                                        className={classNames(
                                            'inline-flex w-full my-2',
                                            {
                                                'ml-2': i === 0,
                                            }
                                        )}
                                        key={activity.activityId}
                                        value={activity.activityId}
                                    >
                                        {activity.activityName}
                                    </Checkbox>
                                );
                            })
                        ) : (
                            <div className="grid items-center justify-center">
                                <IconEmpty />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="flex justify-center items-center space-x-4 pt-6">
                <>
                    <Button
                        type="primary"
                        onClick={_handelClose}
                        size="large"
                        ghost
                    >
                        {t('common.Cancel')}
                    </Button>

                    <Button
                        loading={loading}
                        size="large"
                        type="primary"
                        onClick={saveActivity}
                    >
                        {t('Submit')}
                    </Button>
                </>
            </div>
        </Modal>
    );
};

const xIcon = (
    <svg
        width="8"
        height="9"
        viewBox="0 0 8 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M4.5771 4.49972L7.50679 1.00753C7.55589 0.949498 7.5146 0.861328 7.43871 0.861328H6.54808C6.49563 0.861328 6.4454 0.884766 6.4108 0.924944L3.99451 3.80552L1.57821 0.924944C1.54473 0.884766 1.49451 0.861328 1.44094 0.861328H0.550313C0.47442 0.861328 0.433125 0.949498 0.482232 1.00753L3.41192 4.49972L0.482232 7.99191C0.471232 8.00484 0.464175 8.02067 0.461898 8.03749C0.459622 8.05432 0.462222 8.07145 0.46939 8.08684C0.476558 8.10223 0.487993 8.11525 0.502337 8.12434C0.516681 8.13343 0.533332 8.13821 0.550313 8.13811H1.44094C1.49339 8.13811 1.54362 8.11468 1.57821 8.0745L3.99451 5.19392L6.4108 8.0745C6.44429 8.11468 6.49451 8.13811 6.54808 8.13811H7.43871C7.5146 8.13811 7.55589 8.04994 7.50679 7.99191L4.5771 4.49972Z"
            fill="black"
            fill-opacity="0.45"
        />
    </svg>
);

export default ModalAddActivity;
